import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" Good luck: ")]),_c(VRow,_vm._l((_vm.players),function(player,index){return _c(VCol,{key:index,attrs:{"player":player}},[_c('sn-user-btn',{attrs:{"user":_vm.userFor(player),"x-small":"","color":_vm.colorByPID(player.id)}},[_vm._v(" "+_vm._s(_vm.nameFor(player))+" ")])],1)}),1),_c('div',[_vm._v(" Have fun. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }